import { OrderModel } from './order'

export interface ProfitSharingModel {
  bankType: string;
  createdAt: string;
  errCode: string;
  errCodeDes: string;
  id: number;
  orderId: number;
  profitSharingNumber: string;
  timeEnd: string;
  totalPrice: number;
  tradeType: string;
  transactionNumber: string;
  updatedAt: string;
  order: OrderModel;
}

export const ProfitSharingsFindOrdersBy: {
  [key: string]: string;
} = {
  creatorId: 'CREATOR_ID',
  modifierId: 'MODIFIER_ID',
  createdAt: 'CREATED_AT',
  status: 'STATUS',
  totalPrice: 'TOTAL_PRICE',
  updatedAt: 'UPDATED_AT'
}
